import BaseService from './_base.service';

const URL = "/admin/deliverynotesupplier";

export const deliverynotelotesupplierService = {
    pageFilter,
    allFilterPdf,
    allFilterExcel,
    allFilterWord
};

function pageFilter(page,size,filter,callback) {
    return BaseService.post(URL+"/product/page/"+page+"/"+size, filter, callback, true)
}
function allFilterPdf(filter,callback) {
    let body = JSON.stringify(filter)
    return BaseService.postFile(URL+"/list/pdf", filter,"albaranesrecibidos.pdf", callback,)
}


function allFilterExcel(filter,callback) {
    let body = JSON.stringify(filter)
    return BaseService.postFile(URL+"/list/excel", filter,"albaranesrecibidos.xlsx", callback,)
}


function allFilterWord(filter,callback) {
    let body = JSON.stringify(filter)
    return BaseService.postFile(URL+"/list/word", filter,"albaranesrecibidos.doc", callback,)
}